angular.module('admin.directives')

  .directive('realEstateAgents', ['HelperService', 'RealEstateAgentService', 'AgentService', function(helpers, RealEstateAgentService, AgentService){
    return {
      restrict: 'EA',
      controllerAs: 'reAgentsCtrl',
      bindToController: {
        agent: '=',
      },
      scope: {},
      templateUrl: function(el, attrs){
        return attrs.templateUrl || '/admin/templates/partials/real-estate-agents-list.html';
      },

      controller: function(){
        var ctrl = this;
        ctrl.loading = true;

        ctrl.refreshData = function(){
          function onSuccess(agents){
            ctrl.agents = helpers.sortRealEstateAgents(agents);
            ctrl.loading = false;
          }

          function onError(err){
            ctrl.error = err;
          };

          AgentService.realEstateAgents(ctrl.agent.id)
            .then(onSuccess)
            .catch(onError);
        };

        ctrl.refreshData();
      }
    }

  }]);
